import React from 'react';
import {Modal, Input, Typography} from 'antd';

export interface SelectMoveProps {
  visible?: boolean,
  onOk?: () => void,
  onCancel?: () => void,
  title?: string,
  onChange?: (e:  React.ChangeEvent<HTMLInputElement>) => void,
  placeholder?: string;
  value: string;
}

const ModalInput: React.FC<SelectMoveProps> = props => {

  const {visible, onOk, onCancel, title, placeholder, onChange, value} = props;
  
  let errorText = false
  
  if (value.length !== 0) {
    if (/^[A-Za-z0-9\u4e00-\u9fa5]+$/.test(value) === false) {
      errorText = true
    }
  
    const length = value.replace(/[\u4e00-\u9fa5]/g,'00').length;
  
    if (length > 10 ) {
      errorText = true
    }
  }
  
  return (
    <Modal
      title={title}
      visible={visible}
      onOk={errorText ? () => {} : onOk}
      onCancel={onCancel}
    >
      <Input onChange={onChange} placeholder={placeholder} value={value}></Input>
      {errorText ?
        <Typography.Text type="danger">长度不超过1-10位字符，仅支持中文、英文及数字</Typography.Text>
      : null
      }
      
    </Modal>
  )

}

ModalInput.defaultProps = {
  visible: true,
  onOk: () => {},
  onCancel:  () => {},
  title: '弹窗',
  placeholder: '请输入'
}

export default ModalInput;
